import * as React from 'react';
import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';
import { stringify } from 'qs';

import { getSiteType } from '../../utils/getSiteType';
import { useSelector } from 'react-redux';
import { selectQueryParams, selectDeviceType, selectPageType } from '../../selectors/page';
import { selectFilters } from '../../selectors/filters';
import { EPageTypes } from '../../constants/page';
import { mapPageTypeToAnalytics } from '../../utils/getPageviewObject';

export interface ITrackCalculateClickParams {
  queryString: string;
  deviceType: TDeviceType;
  category: EPageTypes;
  address?: string;
  area?: number;
  roomsCount?: number;
  houseArea?: number;
  landArea?: number;
}

export function trackCalculateClick(params: ITrackCalculateClickParams) {
  const { queryString, deviceType, address, area, roomsCount, category, houseArea, landArea } = params;

  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'Click',
    label: 'Calculate',
    page: {
      pageType: category,
      siteType: getSiteType(deviceType),
      queryString,
      extra: {
        address: address || undefined,
        area: area || undefined,
        roomsCount: roomsCount || undefined,
        houseArea: houseArea || undefined,
        landArea: landArea || undefined,
      },
    },
  });
}

export const useTrackCalculateClick = () => {
  const queryParams = useSelector(selectQueryParams);
  const queryString = stringify(queryParams);
  const deviceType = useSelector(selectDeviceType);
  const pageType = useSelector(selectPageType);
  const { address, area, roomsCount } = useSelector(selectFilters);

  return React.useCallback(() => {
    trackCalculateClick({
      category: mapPageTypeToAnalytics[pageType],
      queryString,
      deviceType,
      address,
      area,
      roomsCount,
    });
  }, [address, area, deviceType, pageType, queryString, roomsCount]);
};
